/**
 * Gets the correct image URL from gallery data
 * Handles both old format (direct URL) and new format (object with url property)
 * @param {Array} gallery - Gallery array
 * @param {number} index - Index of the image (default: 0)
 * @returns {string|null} - Image URL or null if not found
 */
export const getGalleryImageUrl = (gallery, index = 0) => {
  if (!gallery || !Array.isArray(gallery) || gallery.length === 0) {
    return null
  }

  const item = gallery[index]
  if (!item) {
    return null
  }

  // New format: item.url
  if (item.url) {
    return item.url
  }

  // Old format: item is the URL string
  if (typeof item === 'string') {
    return item
  }

  return null
}

/**
 * Gets the correct alt text from gallery data
 * Handles both old format (no alt) and new format (object with alt property)
 * @param {Array} gallery - Gallery array
 * @param {number} index - Index of the image (default: 0)
 * @returns {string} - Alt text or empty string if not found
 */
export const getGalleryImageAlt = (gallery, index = 0) => {
  if (!gallery || !Array.isArray(gallery) || gallery.length === 0) {
    return ''
  }

  const item = gallery[index]
  if (!item) {
    return ''
  }

  // New format: item.alt
  if (item.alt) {
    return item.alt
  }

  // Old format: no alt text available
  return ''
}

/**
 * Gets both URL and alt text from gallery data
 * @param {Array} gallery - Gallery array
 * @param {number} index - Index of the image (default: 0)
 * @returns {Object} - Object with url and alt properties
 */
export const getGalleryImageData = (gallery, index = 0) => {
  return {
    url: getGalleryImageUrl(gallery, index),
    alt: getGalleryImageAlt(gallery, index),
  }
}
